import { FC } from 'react';

export const Container: FC = ({ children }) => {
    return <div className='container xl:px-10 mt-5 lg:mt-0'>{children}</div>;
};
